import { hexToBytes } from '@train-protocol/sdk';
import { getContractInstance } from '../helpers';
export async function buildRefundTx(signer, params, node) {
    const { contract } = await getContractInstance(params.contractAddress, signer, node);
    const hashlockBytes = hexToBytes(params.id, 32);
    return contract.methods.refund_user(hashlockBytes);
}
